// A localized string is of the form: 'english term|french term|german term'
// The localize function picks the appropriate substring based on the language code.
// Almost all strings the user sees are localized.

export function localize(textAlternatives, language) {
	// console.log('localize', textAlternatives, language)
	if (!textAlternatives?.includes('|')) return textAlternatives

	const alternatives = textAlternatives?.split('|')
	switch (language) {
		case 'en':
			return alternatives[0]
		case 'fr':
			return alternatives[1]
		case 'de':
			return alternatives[2]
		default:
			return alternatives[0] // shouldn't happen
	}
}
